import React, { useEffect, useState } from 'react';
import style from './EmailVerify.module.css';
import { useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';

const EmailVerify = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const token = searchParams.get('xyz');
  const [msg, setMsg] = useState('Waiting...');
  const navigate = useNavigate();

  useEffect(() => {
    async function verify() {
      const res = await axios.post(`/user/verify-email/${token}`, {
        headers: { 'Access-Control-Allow-Origin': '*' },
        withCredentials: true,
      });
      if (res.data.msg === 'Verification Failed')
        setMsg('Account Verification Failed!');
      else if (res.data.msg === 'Verification Successful') {
        setMsg('Account Verification Successful!');
        setTimeout(() => {
          navigate('/login');
        }, 2000);
      }
    }
    verify();
  });

  return (
    <div className={style.Login}>
      <p>{msg}</p>
    </div>
  );
};

export default EmailVerify;
